/** @module clipBoardUtils */
/**
 * @see https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript
 */

/* eslint-disable no-console */

/**
 * @function fallbackCopyTextToClipboard
 * @param {string} text
 */
const fallbackCopyTextToClipboard = text => {
  const textArea = document.createElement('textarea');

  textArea.value = text;

  document.body.appendChild(textArea);

  textArea.focus();
  textArea.select();

  try {
    const successful = document.execCommand('copy');
    const msg = successful ? 'successful' : 'unsuccessful';

    console.log(`Fallback: Copying text command was ${msg}`);
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
  }

  document.body.removeChild(textArea);
};

/**
 * @function copyTextToClipboard
 * @async
 * @param {string} text
 */
export const copyTextToClipboard = async text => {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);

    return;
  }

  try {
    navigator.clipboard.writeText(text);
    console.log('Async: Copying to clipboard was successful!');
  } catch (error) {
    console.error('Async: Could not copy text: ', error);
  }
};
